import type { PostModalMode } from './types';

export const ITEM_CLASS_MAP: Record<string, string> = {
  UBInboxMessage: 'message',
  UBComment: 'comment',
  UBClassRoomPost: 'post',
};

export const POST = 'Post';
export const CANCEL = 'Cancel';

export const DEFAULT_ITEM_CLASS = 'UBClassRoomPost';

export const MESSAGES = {
  edit: {
    success: 'The post has been saved',
    error: 'The post has not been saved',
  },
  create: {
    success: 'A new post has been added',
    error: 'The post has not been added',
  },
} as const;

export const getModalTitle = (mode: PostModalMode, itemLabel: string) =>
  mode === 'create' ? `Create ${itemLabel}` : `Edit ${itemLabel}`;
